module.exports = __webpack_public_path__ + "./docs/img/scheme_1.a522392f8cdb142f999fe5de0cae2972.svg";